import { Field, FieldHookConfig, useField } from "formik";
import React, { useReducer } from "react";
import { Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { MultiEditField } from "../../../models";

export interface OdsMultiDateProps {
    label: string;
}

export const OdsMultiDate: React.FC<OdsMultiDateProps & FieldHookConfig<MultiEditField<Date | undefined | null>>> = ({
    label,
    ...props
}) => {
    const [field, meta, helpers] = useField(props);

    const doValueChanged = (selected: Date | null) => {
        helpers.setValue(new MultiEditField(selected, true), true);
    }

    const doUpdateChanged = (update: React.ChangeEvent<HTMLInputElement>) => {
        helpers.setValue(new MultiEditField(field.value?.value, !(field.value?.update ?? true)), true);
    }

    return (
        <Row>
            <Col md="auto">
                <Form.Group controlId={`${field.name}Update`}>
                    <Form.Label>Update&nbsp;&nbsp;</Form.Label>
                    <Form.Check
                        name={`${field.name}Update`}
                        type="switch"
                        placeholder={`Update ${label}`}
                        checked={field.value?.update ?? false}
                        onChange={doUpdateChanged}
                        onBlur={field.onBlur}
                        isInvalid={!!meta.touched && !!meta.error}
                    />
                    <Form.Control.Feedback type="invalid">
                        {meta.error}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col>
                <Form.Group controlId={field.name}>
                    <Form.Label>{label}</Form.Label>
                    <DatePicker
                        className="form-control"
                        selected={field.value?.value || undefined}
                        onChange={doValueChanged}
                        closeOnScroll={true}
                        popperProps={{
                            positionFixed: true
                        }}
                    />
                    <Form.Control.Feedback type="invalid">
                        {meta.error}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>
    )
};
